module.exports = __webpack_public_path__ + "static/media/ccc.1dc2d194.jpg";